.atm_40_5l98or{border-bottom:1px solid #A1A8B0;}
.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_fc_1yb4nlp.atm_fc_1yb4nlp{justify-content:space-between;}
.atm_l8_10029f0{padding:16px 0px;}
.atm_931566_5l98or :first-of-type{border-top:1px solid #A1A8B0;}
.atm_gi_mi1bkg{margin:0px 16px 0px 0px;}
.atm_am_kb7nvz{flex:1;}
.atm_ks_15vqwwr{overflow:hidden;}
.atm_sq_1l2sidv{text-overflow:ellipsis;}
.atm_vv_1q9ccgz{white-space:nowrap;}
